import React from 'react';
import classNames from 'classnames';
import styles from './Banner.module.scss';

export interface Props {
  children?: React.ReactNode;
  id?: string;
  dataTestId?: string;
  noContainer?: boolean;
  role?: React.AriaRole;
  ariaLabel?: string;
}

export function Banner(props: Props) {
  const { id, dataTestId, children, noContainer = false, role, ariaLabel } = props;
  return (
    <div
      id={id}
      data-testid={dataTestId}
      role={role}
      aria-label={ariaLabel}
      className={classNames('optionalBanner', {
        [styles.outerContainer]: !noContainer,
      })}
    >
      <div className={classNames(styles.innerContainer, { [styles.innerContainerNoContainer]: noContainer })}>
        {children}
      </div>
    </div>
  );
}
